module.exports = __webpack_public_path__ + "img/TERMINAR.ff35f18b.png";